<template>
  <div class="smarthome">
    <!-- -->
    <div class="section-wrapper smarthome-header">
      <div class="smarthome-header-shadow mask-left active">
        <div class="header-title">
          <h2>{{ content.name }}</h2>
          <h3>{{ content.metaTitle }}</h3>
        </div>
      </div>
    </div>

    <!-- content -->
    <div class="smarthome-main-content">
      <h4>{{ content.metaDescription }}</h4>

      <img
        class="smarthome-img hideonmobile"
        v-bind:src="
          require('../assets/content/' +
            this.locale +
            '-rise-smarthome-img.jpg')
        "
        alt=""
      />

      <img
        class="smarthome-img hideondesktop"
        v-bind:src="
          require('../assets/content/' +
            this.locale +
            '-rise-smarthome-img-mobile.jpg')
        "
        alt=""
      />

      <!-- cta mobile -->
      <router-link
        v-bind:to="'/project/precupetii-vechi?cta=smart-home'"
        class="button btn-smarthome hideondesktop"
        ><svg
          width="42"
          height="43"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <ellipse cx="21" cy="21.368" rx="21" ry="21.368" fill="#fff" />
          <path
            d="M5.248 16.962L21.442 3l16.1 13.962"
            stroke="#000"
            stroke-width=".659"
            stroke-linecap="round"
          />
          <path
            d="M10.185 12.118V6.42h3.04v3.419m-3.942 20.61V16.536L21.346 6.42l12.062 10.115V30.45h-9.165.838H9.283z"
            stroke="#000"
            stroke-width=".659"
            stroke-linecap="round"
          />
          <path
            stroke="#000"
            stroke-width=".659"
            d="M5.578 31.787h31.634v1.884H5.578z"
          />
          <path
            d="M12.998 17.966c2.584-2.583 10.011-6.007 16.793 0M15.582 20.355c1.888-1.95 6.985-4.678 12.272 0M18.168 22.293c1.093-.975 4.044-2.34 7.105 0"
            stroke="#000"
            stroke-width=".659"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <circle
            cx="21.397"
            cy="24.877"
            r="1.608"
            stroke="#000"
            stroke-width=".659"
          /></svg
        >{{ strings.vezi_config_smarthome }}</router-link
      >

      <!-- content already in p -->
      <p v-html="content.text"></p>

      <!-- cta desktop -->
      <router-link
        v-bind:to="'/project/precupetii-vechi?cta=smart-home'"
        class="button btn-smarthome hideonmobile"
        ><svg
          width="42"
          height="43"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <ellipse cx="21" cy="21.368" rx="21" ry="21.368" fill="#fff" />
          <path
            d="M5.248 16.962L21.442 3l16.1 13.962"
            stroke="#000"
            stroke-width=".659"
            stroke-linecap="round"
          />
          <path
            d="M10.185 12.118V6.42h3.04v3.419m-3.942 20.61V16.536L21.346 6.42l12.062 10.115V30.45h-9.165.838H9.283z"
            stroke="#000"
            stroke-width=".659"
            stroke-linecap="round"
          />
          <path
            stroke="#000"
            stroke-width=".659"
            d="M5.578 31.787h31.634v1.884H5.578z"
          />
          <path
            d="M12.998 17.966c2.584-2.583 10.011-6.007 16.793 0M15.582 20.355c1.888-1.95 6.985-4.678 12.272 0M18.168 22.293c1.093-.975 4.044-2.34 7.105 0"
            stroke="#000"
            stroke-width=".659"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <circle
            cx="21.397"
            cy="24.877"
            r="1.608"
            stroke="#000"
            stroke-width=".659"
          /></svg
        >{{ strings.vezi_config_smarthome }}</router-link
      >
    </div>

    <!-- Footer -->
    <div class="section-wrapper section-wrapper--footer">
      <div class="footer-shadow mask-left active">
        <h2>{{ strings.contact_titlu }}</h2>
      </div>

      <div
        class="footer mask-right active"
        :style="{
          backgroundImage: 'url(' + homepageImgs.homepage_7 + ')'
        }"
      >
        <div class="footer-wrapper">
          <div class="footer-wrapper-text content active">
            <h4>{{ strings.footer_titlu }}</h4>
            <p>{{ strings.footer_text }}</p>
          </div>
          <div class="footer-wrapper-form content active">
            <h5>{{ strings.footer_form_title }}</h5>

            <!-- mobile -->
            <div class="call-us">
              <h5>{{ strings.prin_telefon }}</h5>
              <a :href="'tel:' + contact_tel" class="button">{{
                contact_tel
              }}</a>
              <h5>{{ strings.prin_email }}</h5>
            </div>

            <form
              class="ask-us form-styles"
              @submit="submitForm"
              action="#"
              method="post"
            >
              <input
                type="hidden"
                id="form_type"
                name="form_type"
                value="contact"
              />
              <input
                type="text"
                v-model="user_name"
                name="user_name"
                value=""
                :placeholder="strings.programeaza_intalnire_nume"
              />
              <input
                type="email"
                v-model="user_email"
                name="email"
                value=""
                :placeholder="strings.programeaza_intalnire_email"
              />
              <input
                type="tel"
                v-model="user_phone"
                pattern="[0-9]{4}[0-9]{3}[0-9]{3}"
                name="tel"
                value=""
                :placeholder="strings.programeaza_intalnire_tel"
              />
              <textarea
                name="mesaj"
                v-model="user_message"
                rows="8"
                cols="80"
                :placeholder="strings.programeaza_intalnire_mesaj"
              ></textarea>
              <!-- newsletter -->
              <div class="gdpr_wrapper">
                <input
                  type="checkbox"
                  id="label_subscribe_newsletter_footer"
                  name="label_subscribe_newsletter_footer"
                  value="true"
                />
                <span class="checkmark"></span>
                <label
                  class="label_subscribe_newsletter"
                  for="label_subscribe_newsletter_footer"
                  >{{ strings.subscribe_newsletter }}</label
                >
              </div>

              <!-- t&c -->
              <div class="gdpr_wrapper">
                <input
                  type="checkbox"
                  id="accept_tc_2"
                  name="accept_tc_2"
                  value="Accept T&C"
                  required
                />
                <span class="checkmark"></span>
                <label
                  class="label_accept_tc_1 label_accept_tc_2"
                  for="accept_tc_2"
                  >{{ strings.programeaza_intalnire_accept_termeni }}</label
                >
              </div>

              <input
                type="submit"
                :value="strings.programeaza_intalnire_accept_trimite"
              />
            </form>
          </div>
        </div>
      </div>
    </div>

    <!-- footer social -->
    <div class="social-footer">
      <div class="social-footer-wrapper">
        <div class="social-footer-network">
          <a href="#" class="icon fb">
            <svg
              width="64"
              height="34"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                width="59.2"
                height="24.9"
                rx="12.5"
                transform="rotate(8.1 .2 31.5)"
                fill="#F9DF41"
              />
              <path
                d="M28 32.5h6.5V16.3H39l.4-5.5h-4.9v-3c0-1.4.3-2 1.6-2h3.5V.4H35c-4.8 0-7 2-7 6.1v4.4h-3.4v5.5h3.4v16.2H28z"
                fill="#222221"
              />
            </svg>
          </a>
          <a href="#" class="icon ig"
            ><svg
              width="63"
              height="34"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                width="59.2"
                height="24.9"
                rx="12.5"
                transform="rotate(8.1 0 27.5)"
                fill="#F9DF41"
              />
              <path
                d="M31.2 5.7c4 0 4.3 0 5.9.2a5 5 0 012.6.5c.7.3 1.1.6 1.7 1.2.6.5.8 1 1.1 1.6.2.6.4 1.3.6 2.7l.1 5.9-.1 5.9a5 5 0 01-.6 2.6c-.3.7-.5 1.2-1 1.7-.7.6-1 .9-1.8 1.1-.5.2-1.2.5-2.6.6l-6 .1-5.8-.1a5 5 0 01-2.7-.6c-.7-.2-1-.5-1.6-1-.6-.6-.9-1-1.2-1.8-.1-.5-.4-1.2-.5-2.6-.2-1.6-.2-2-.2-6 0-3.8 0-4.3.2-5.8a5 5 0 01.5-2.7c.3-.7.6-1 1.2-1.6.5-.6 1-.9 1.6-1.2.6-.1 1.3-.4 2.7-.5 1.4-.2 2-.2 5.9-.2zm0-2.6l-6 .1c-1.6.2-2.7.3-3.5.7-1 .4-1.9.9-2.6 1.7-.8.8-1.2 1.7-1.6 2.5-.5 1-.6 2-.7 3.5-.2 1.6-.2 2.1-.2 6 0 4 0 4.5.2 6 0 1.6.2 2.7.7 3.6.4 1 .8 1.8 1.6 2.5.9.8 1.7 1.3 2.6 1.7 1 .4 2 .5 3.5.7l6 .1 6-.1c1.5-.2 2.7-.3 3.5-.7 1-.4 1.8-.9 2.5-1.7.9-.8 1.3-1.7 1.7-2.5.4-1 .6-2 .7-3.5.2-1.6.2-2.1.2-6 0-4 0-4.5-.2-6C45.5 10 45.3 9 45 8c-.4-1-.8-1.8-1.7-2.5a8.8 8.8 0 00-2.5-1.7c-1-.4-2-.5-3.5-.7l-6-.1z"
                fill="#222221"
              />
              <path
                d="M31.2 10.2a7.5 7.5 0 00-7.6 7.6c0 4.2 3.4 7.6 7.6 7.6 4.2 0 7.5-3.4 7.5-7.6a7.7 7.7 0 00-7.5-7.6zm0 12.5a5 5 0 01-5-5 5 5 0 015-4.8 5 5 0 014.9 4.9c-.2 2.7-2.3 4.9-5 4.9zM40.7 10c0 1-.8 1.8-1.8 1.8S37 10.9 37 9.9c0-1 .8-1.8 1.8-1.8 1 .2 1.8.9 1.8 1.8z"
                fill="#222221"
              /></svg
          ></a>
          <a href="#" class="icon in">
            <svg
              width="63"
              height="34"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                width="59.2"
                height="24.9"
                rx="12.5"
                transform="rotate(8.1 .2 30.7)"
                fill="#F9DF41"
              />
              <path fill="#000" d="M14.9 10.2h7.4v22.7h-7.4z" />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M33.9 19.7c.5-1.6 2-3.7 4.4-3.7 2.3 0 3.5 2.3 3.5 3.4h7.4c0-1.9-.5-6-4-8.3-1.4-1-5.3-2.3-8.8 0-.8.6-1.8 1.7-2.5 3v-4h-7.4V33h7.4V19.7zm7.9-.3h7.4V33h-7.4V19.4z"
                fill="#000"
              />
              <ellipse cx="18.9" cy="3.7" rx="3.9" ry="3.7" fill="#000" />
            </svg>
          </a>
        </div>
        <span
          ><router-link v-bind:to="'/privacypolicy'">
            {{ strings.privacy_title }}
          </router-link></span
        >
        <span>{{ strings.all_rights_reserved }}</span>
      </div>
      <!-- scroll to top -->
      <div class="scroll-to-top">
        <a href="#" @click.prevent="scrollTo('.smarthome-header')">
          <svg
            width="24"
            height="34"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13 1c-.5-.6-1.5-.6-2 0l-9.6 9.5a1.5 1.5 0 102.1 2.1L12 4.1l8.5 8.5a1.5 1.5 0 102.1-2.1L13.1.9zm.5 33V2h-3v32h3z"
              fill="#000"
            />
          </svg>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import router from "../router";
import { bus } from "../main";
import axios from "axios";

export default {
  name: "PrivacyPolicy",
  components: {},
  data() {
    return {
      locale: "",
      content: {
        name: "",
        metaTitle: "",
        metaDescription: "",
        text: ""
      },
      strings: {
        home_proiectele_noastre: "",
        programeaza_intalnire_cta: "",
        programeaza_intalnire_headline: "",
        programeaza_intalnire_thanks: "",
        contact_titlu: "",
        footer_titlu: "",
        footer_text: "",
        footer_form_title: "",
        programeaza_intalnire_accept_trimite: "",
        all_rights_reserved: "",
        vezi_harta: "",
        ask_us_thankyou: "",
        prin_telefon: "",
        prin_email: "",
        evolutie_h2: "",
        evolutie_h3: "",
        toneotel: "",
        concrete: "",
        months: "",
        tofinish: "",
        evolutie_in_timp: "",
        finalizare: "",
        deschide_toate: "",
        inchide_toate: "",
        date: "",
        evolutie_nl_h4: "",
        evolutie_nl_h5: "",
        pozitionare_proiecte_map_title: "",
        vezi_config_smarthome: ""
      },
      homepageImgs: {
        homepage_7: ""
      },
      form_type: "",
      user_name: "",
      user_email: "",
      user_phone: "",
      user_message: "",
      fbUrl: "",
      igUrl: "",
      liUrl: "",
      contact_tel: ""
    };
  },
  methods: {
    fetchHomeImgs: function() {
      var self = this;
      // get homepage images
      axios
        .get("https://api.riseapart.com")
        .then(function(res) {
          var images = res.data.mediaFiles;
          self.homepageImgs.homepage_7 = images.homepage_7;
        })
        .catch(function(error) {
          console.log("Error", error);
        });
    },
    fetchData: function() {
      var self = this;

      // reset strings
      self.strings.programeaza_intalnire_cta = "";
      self.strings.programeaza_intalnire_headline = "";
      self.strings.programeaza_intalnire_thanks = "";
      self.strings.pozitionare_proiecte_map_title = "";
      self.strings.all_rights_reserved = "";

      // content
      axios
        .get("https://api.riseapart.com/cms", {
          headers: {
            "X-Locale": self.locale
          }
        })
        .then(function(data) {
          var list = data.data.data;

          var result = list.filter(obj => {
            return obj.status == 1;
          });

          self.content.name = result[0].name;
          self.content.metaTitle = result[0].metaTitle;
          self.content.metaDescription = result[0].metaDescription;
          self.content.text = result[0].content;
        })
        .catch(function(error) {
          console.log("Error", error);
        });

      // get translatable strings
      axios
        .get("https://api.riseapart.com/content?_limit=100", {
          headers: { "X-Locale": self.locale }
        })
        .then(function(data) {
          let stringsObj = data.data.data;
          let x;

          // get all strings
          for (x = 0; x < stringsObj.length; x++) {
            let newObj = stringsObj[x];
            let newKey = Object.keys(newObj);
            self.strings[newObj[newKey].key] = newObj[newKey].value;
          }

          // console.log("the strings are:", self.strings);
        })
        .catch(function(error) {
          console.log("Error", error);
        });

      // get settings (social urls)
      axios
        .get("https://api.riseapart.com/configuration")
        .then(function(res) {
          var facebookUrl = res.data.data.filter(obj => {
            return obj.key === "FACEBOOK_URL";
          });

          var instagramUrl = res.data.data.filter(obj => {
            return obj.key === "INSTAGRAM_URL";
          });

          var linkedinUrl = res.data.data.filter(obj => {
            return obj.key === "LINKEDIN_URL";
          });

          var contactTel = res.data.data.filter(obj => {
            return obj.key === "CONTACT_TEL";
          });

          self.fbUrl = facebookUrl[0].defaultValue;
          self.igUrl = instagramUrl[0].defaultValue;
          self.liUrl = linkedinUrl[0].defaultValue;
          self.contact_tel = contactTel[0].defaultValue;
        })
        .catch(function(error) {
          console.log("Error", error);
        });
    },
    submitForm(e) {
      e.preventDefault();

      // console.log(e);
      var form = e.srcElement;
      var form_type = form.querySelector("#form_type").value;

      let bodyFormData = new FormData();
      // if (
      //   parseInt(
      //     document
      //       .querySelector(".smarthome-controller")
      //       .getAttribute("data-index")
      //   ) === 0
      // ) {
      //   bodyFormData.set("project", this.content.precupeti.id);
      // } else {
      //   bodyFormData.set("project", this.content.fainari.id);
      // }
      bodyFormData.set("type", form_type);
      bodyFormData.set("email", this.user_email);
      bodyFormData.set("name", this.user_name);
      bodyFormData.set("phone", this.user_phone);
      bodyFormData.set("message", this.user_message);
      bodyFormData.set("tos", "true");

      // set loading animation on button
      form.querySelector('input[type="submit"]').classList.add("loading");

      if (
        document.querySelector("#label_subscribe_newsletter_footer") ||
        document.querySelector("#label_subscribe_newsletter_footer").checked
      ) {
        bodyFormData.set("news", true);
      }

      axios({
        method: "post",
        url: "https://api.riseapart.com/send-form",
        data: bodyFormData,
        headers: { "Content-Type": "multipart/form-data" }
      })
        .then(function(response) {
          // stop loading animation
          form
            .querySelector('input[type="submit"]')
            .classList.remove("loading");

          // handle success
          if (response.data.data.sent === 1 && form_type === "contact") {
            form.reset();
            self.user_name = "";
            self.user_email = "";
            self.user_phone = "";
            self.user_message = "";
            form.parentElement.querySelector("h5")[0].innerHTML =
              self.strings.ask_us_thankyou;

            console.log(self.strings.ask_us_thankyou);
          }
          console.log(self.strings.ask_us_thankyou);
        })
        .catch(function(response) {
          // stop loading animation
          form
            .querySelector('input[type="submit"]')
            .classList.remove("loading");

          //handle error
          // console.log("error: " + response);

          if (response.name) {
            form
              .querySelector("input[name='user_name']")
              .classList.add("error");
          }

          if (response.email) {
            form
              .querySelector("input[name='user_email']")
              .classList.add("error");
          }

          if (response.phone) {
            form
              .querySelector("input[name='user_phone']")
              .classList.add("error");
          }
        });
    },
    scrollTo(el) {
      // document.querySelector(el).scrollIntoView({
      //   behavior: "smooth"
      // });
      const yOffset = -180;
      const element = document.querySelector(el);
      const y =
        element.getBoundingClientRect().top + window.pageYOffset + yOffset;

      window.scrollTo({ top: y, behavior: "smooth" });
    }
  },
  async mounted() {
    // this.initMaps();
    // get homepage images
    await this.fetchHomeImgs();
  },
  updated: function() {},
  created() {
    // langCheck
    // console.log(this.$route.query.lang);
    if (!this.$route.query.lang) {
      router.push({ query: { lang: "ro" } });
      this.locale = "ro";
    } else {
      this.locale = this.$route.query.lang;
      this.fetchData();
    }

    // lang switch
    bus.$on("lang", data => {
      this.locale = data.lang;
      this.fetchData();
    });
  },
  beforeCreate: function() {
    document.body.className = "class-project-smarthome";
  },
  beforeDestroy() {
    // window.removeEventListener("resize", this.mq);
  }
};
</script>

<style lang="scss">
@import "~@/assets/styles/_reset.scss";
@import "~@/assets/styles/_variables.scss";
@import "~@/assets/styles/_components.scss";
@import url("https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;600&display=swap");

html {
  scroll-behavior: smooth;
}

.class-project-smarthome {
  .vue-fixed-header {
    svg > g > path:nth-child(1) {
      fill: $color-light;
      transition: fill 0.3s ease;
    }
  }

  .vue-fixed-header.vue-fixed-header--isFixed {
    svg > g > path:nth-child(1) {
      fill: $color-yellow;
      transition: fill 0.3s ease;
    }
  }
}

.mask-left {
  -webkit-mask-image: url("~@/assets/mask-left.png");
  mask-image: url("~@/assets/mask-left.png");
  -webkit-mask-position: -20vw -4vh;
  mask-position: -20vw -4vh;
  -webkit-mask-repeat: no-repeat;
  mask-repeat: no-repeat;
  -webkit-mask-size: 120vw 100vh;
  mask-size: 120vw 100vh;
  object-fit: cover;
  transition: -webkit-mask-position 1s ease 0.4s;

  &.active {
    -webkit-mask-position: 0 0;
    mask-position: 0 0;
  }

  @media screen and (max-width: 1200px) {
    -webkit-mask-position: 0 0;
    mask-position: 0 0;
    -webkit-mask-repeat: no-repeat;
    mask-repeat: no-repeat;
    -webkit-mask-size: 140vw 90vh;
    mask-size: 140vw 90vh;
    object-fit: cover;
    transition: none;

    &.active {
      -webkit-mask-position: 0 0;
      mask-position: 0 0;
    }
  }

  @media screen and (max-width: 768px) {
    -webkit-mask-position: 0 0;
    mask-position: 0 0;
    -webkit-mask-repeat: no-repeat;
    mask-repeat: no-repeat;
    -webkit-mask-size: 1920px 940px;
    mask-size: 1920px 940px;
    object-fit: cover;
    transition: none;

    &.active {
      -webkit-mask-position: 0 0;
      mask-position: 0 0;
    }
  }
}

.smarthome-header-shadow {
  position: relative;
  display: block;
  width: 100vw;
  height: 70vh;
  background-color: $blue-smart;
  z-index: 92;

  &.mask-left {
    -webkit-mask-size: 150vw 70vh;
    mask-size: 150vw 70vh;
  }

  @media screen and (min-width: 1024px) {
    height: 100vh;

    &.mask-left {
      -webkit-mask-size: 1920px 940px;
      mask-size: 1920px 940px;
    }
  }

  .header-title {
    position: absolute;
    top: 25%;
    right: 0;
    left: 0;

    @media screen and (min-width: 1024px) {
      top: 36%;
      h2 {
        max-width: 60vw;
        margin: 0 auto;
      }
    }
  }

  h2 {
    position: relative;
    max-width: 76vw;
    margin: 0 auto;
    font-family: "Poppins", sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 30px;
    line-height: 120%;
    letter-spacing: -0.015em;
    text-transform: none;
    color: $color-dark;

    @media screen and (min-width: 1024px) {
      font-size: 66px;
    }
  }

  h3 {
    position: relative;
    max-width: 60vw;
    margin: 40px auto 0;
    font-family: "Poppins", sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
    line-height: 120%;
    letter-spacing: -0.015em;
    text-transform: none;
    color: $color-dark;
    text-align: center;

    @media screen and (min-width: 1024px) {
      font-size: 30px;
      max-width: 76vw;
    }
  }
}

.smarthome {
  .call-us {
    display: none;
  }

  .hideonmobile {
    @media screen and (max-width: 1023px) {
      display: none !important;
    }
  }

  .hideondesktop {
    @media screen and (min-width: 1024px) {
      display: none !important;
    }
  }

  &-main-content {
    max-width: 80vw;
    margin: 0 auto;

    @media screen and (max-width: 760px) {
      margin-bottom: 60px;
    }

    p {
      @media screen and (min-width: 1024px) {
        max-width: 45vw;
        margin: 20px auto 0;
      }
    }

    h4 {
      position: relative;
      margin: 90px auto 20px;
      font-family: "Poppins", sans-serif;
      font-style: normal;
      font-weight: 600;
      font-size: 18px;
      line-height: 120%;
      letter-spacing: -0.015em;
      text-transform: none;
      color: $color-dark;
      text-align: center;

      @media screen and (min-width: 1024px) {
        max-width: 76vw;
        margin: 90px auto;
        font-size: 30px;
      }
    }
  }

  &-header {
    @media screen and (max-width: 760px) {
      height: 65vh;
    }
  }

  .smarthome-img {
    display: block;
    width: 80vw;
    margin: 0 auto 100px;

    @media screen and (max-width: 760px) {
      width: 100vw;
      margin: 0 0 60px -10vw;
    }
  }

  &-form {
    form {
      margin: 0 auto;

      input[type="submit"] {
        margin: 40px auto 0;
      }
    }

    .newsletter-thanks {
      display: none;
      font-family: "Poppins", sans-serif;
      font-style: normal;
      font-size: 18px;
      line-height: 26px;
      text-align: center;
    }
  }

  p {
    display: block;
    font-family: "Poppins", sans-serif;
    font-style: normal;
    font-weight: 300;
    font-size: 14px;
    line-height: 20px;
    color: $color-dark;

    @media screen and (min-width: 1024px) {
      font-size: 20px;
      line-height: 30px;
    }
  }

  .footer {
    display: block;
    width: 100vw;
    height: 100vh;
    margin-top: 30px;
    margin-left: 0;
    background-image: url("~@/assets/footer-bg.jpg");
    background-size: cover;
    background-position: center center;
    background-repeat: none;
    background-color: $color-light;
    text-align: center;

    // footer form fix
    @media screen and (max-height: 850px) {
      min-height: 900px;
    }

    &-shadow {
      display: block;
      width: 100vw;
      height: 100vh;
      background-color: $color-yellow;

      h2 {
        color: $color-dark;

        @media screen and (max-width: 768px) {
          margin: 50px auto 0;
          font-size: 12px;
          line-height: 18px;
        }
      }
    }

    &-wrapper {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: flex-start;
      width: 100%;
      max-width: calc(1200px - 100px);
      height: 60%;
      margin: 200px auto 0;

      &-logo {
        display: block;
        width: 161px;
        height: 91px;
      }

      &-text {
        display: block;
        width: 17vw;
        min-width: 300px;
        // margin-left: 50px;

        h4,
        p {
          font-family: "Poppins", sans-serif;
          font-style: normal;
        }

        h4 {
          font-weight: 600;
          font-size: 38px;
          line-height: 57px;
          text-align: left;
          color: $color-yellow;
        }

        p {
          font-weight: 300;
          font-size: 18px;
          line-height: 30px;
          text-align: left;
          color: $color-light;
        }
      }

      &-form {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        width: 18vw;
        min-width: 190px;
        max-width: 350px;
        // margin-left: 10.5vw;

        h5 {
          display: block;
          margin: 0 0 30px;
          font-family: "Poppins", sans-serif;
          font-style: normal;
          font-weight: 300;
          font-size: 18px;
          line-height: 30px;
          color: $color-light;
        }

        .ask-us {
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          align-items: flex-start;

          input:not([type="checkbox"]),
          select,
          textarea,
          label,
          button {
            display: block;
            // width: 100%;
            margin-bottom: 12px;
            font-family: "Poppins", sans-serif;
            font-style: normal;
            font-weight: normal;
            font-size: 12px;
            line-height: 18px;
            letter-spacing: 0.2em;
            text-transform: uppercase;
            color: $color-yellow;
            border: 1px solid $color-yellow;
            border-radius: 80px;
            background: transparent;
            outline: none;

            @media screen and (min-width: 1024px) {
              // width: 100%;
            }
          }

          input {
            padding: 7px 15px;
            height: 45px;

            @media screen and (max-width: 768px) {
              height: 35px;
            }
          }

          .select-wrapper {
            display: block;
            width: 100%;
            margin-bottom: 12px;
            padding: 0 9px;
            border: 1px solid $color-yellow;
            border-radius: 80px;
            background: transparent;
          }

          select {
            margin: 0;
            padding: 7px 15px;
            height: 45px;
            border: 0px;
          }

          textarea {
            height: 80px;
            padding: 7px 15px;
            border-radius: 20px;
          }

          ::-webkit-input-placeholder {
            /* Edge */
            color: $color-yellow;
          }

          :-ms-input-placeholder {
            /* Internet Explorer 10-11 */
            color: $color-yellow;
          }

          ::placeholder {
            color: $color-yellow;
          }

          button {
            display: inline-block;
            width: auto;
            margin: 0 0 0 auto;
            padding: 7px 15px;

            &:hover {
              cursor: pointer;
              background-color: $color-yellow;
              color: $color-dark;
            }
          }
        }
      }
    }
  }

  .social-footer {
    position: relative;
    z-index: 120;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    margin: 120px auto;

    &-wrapper {
      display: block;
      width: 230px;
    }

    &-network {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      width: 100%;
    }

    a {
      &:hover {
        cursor: pointer;
      }
    }

    span {
      display: block;
      margin-top: 18px;
      font-family: "Poppins", sans-serif;
      font-style: normal;
      font-weight: normal;
      font-size: 12px;
      text-align: center;
      letter-spacing: -0.015em;
      color: $color-dark;
      text-align: center;
    }
  }
}

@media screen and (min-width: 768px) and (max-width: 1200px) {
  .smarthome {
    .footer {
      height: 140vh;

      &.mask-right {
        -webkit-mask-size: 140vw 1000px;
        mask-size: 140vw 1000px;
      }
    }

    .footer-wrapper {
      flex-direction: column;
      height: auto;

      &-text {
        width: 40vw;
        margin: 0 auto;

        h4 {
          width: 40vw;
          margin: 20px auto;
          font-size: 23px;
          line-height: 29px;
          text-align: center;
        }

        p {
          font-size: 12px;
          line-height: 18px;
          text-align: justify;
        }
      }

      &-form {
        width: 80vw;
        margin: 20px auto 0;

        h5 {
          display: block;
          width: 100%;
          margin: 10px 0 10px;
          font-size: 15px;
          text-align: center;
        }
      }
    }
  }
}

@media screen and (max-width: 760px) {
  .smarthome {
    .section-wrapper--footer {
      height: 1140px;
    }

    .footer {
      height: 1000px;
    }

    .footer.mask-right {
      -webkit-mask-size: 1920px 1080px;
      mask-size: 1920px 1080px;
    }

    .mask-left {
      -webkit-mask-size: 1920px 940px;
      mask-size: 1920px 940px;
    }

    .footer-wrapper {
      flex-direction: column;
      margin-top: 120px;

      &-text {
        width: 80vw;
        margin: 0 auto;

        h4 {
          width: 70%;
          margin: 0 auto;
          font-size: 23px;
          line-height: 29px;
          text-align: center;
        }

        p {
          font-size: 12px;
          line-height: 18px;
          text-align: justify;
        }
      }

      &-form {
        width: 80vw;
        margin: 0 auto;

        h5 {
          display: block;
          width: 100%;
          font-size: 15px;
          text-align: center;
        }
      }
    }

    .social-footer {
      margin: 20px auto;
    }

    .call-us {
      display: block;
      width: 100%;
      margin-bottom: 10px;
      text-align: center;

      h5 {
        margin: 0;
        color: $color-yellow;
      }

      a {
        margin: 5px 0 20px 0 !important;
        font-size: 10px;
        color: $color-dark;
        background: $color-yellow;
      }
    }
  }
}
</style>
